import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMMDfhBI2csD4cXlwBku0nN8M3m2Tx6hE",
  authDomain: "clone-4514b.firebaseapp.com",
  databaseURL: "https://clone-4514b.firebaseio.com",
  projectId: "clone-4514b",
  storageBucket: "clone-4514b.appspot.com",
  messagingSenderId: "829778497919",
  appId: "1:829778497919:web:b8ee771a5a1e7ca7d00a4a",
  measurementId: "G-E882RXR8B3",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
